import { HomeMenuPopout } from "@/base/NewselaGlobalLayoutV2/NavigationBar/HomeMenu/HomeMenuPopout/HomeMenuPopout";

export { HomeMenuPopout };
